import './index.scss'
import React from 'react'
import BaseStructure from '../base'

export class FooterStructure extends BaseStructure {
  constructor(props) {
    const nav = BaseStructure.formatSiteNavLinks(props.nav, props.host)
    super(Object.assign({}, props, {nav: nav}))
    this.customize = this.props.meta.footer_customize
  }
  
  // 预设
  presets() {
    const { meta } = this.props
    // 预设列表
    return [{
      uid: '1',
      html: (
        <div className="container">
          <div className="row">
            <div className="col-sm-8">
              <ul className="list-inline list-links">
                <li>
                  <a href="">公司介绍</a>
                </li>
                <li><span>|</span></li>
                <li>
                  <a href="">联系我们</a>
                </li>
                <li><span>|</span></li>
                <li>
                  <a href="">加入我们</a>
                </li>
                <li><span>|</span></li>
                <li>
                  <a href="">用户协议</a>
                </li>
              </ul>

              <div className="copyright-wrap">
                <span>{meta.copyright.content}</span>
                <a className="icp-wrap" target="_blank" href="http://www.miitbeian.gov.cn/">
                  <i className="fi fi-icp"> </i>
                  <span>{meta.icp_record.content}</span>
                </a>
              </div>
            </div>

            <div className="col-sm-4">
              <ul className="list-inline list-socials">
                {
                  (this.props.socials.entities || []).map((entity, index) =>
                    <li key={index}>
                      <a href={entity.url}>
                        <i className={"fi fi-" + entity.title}> </i>
                      </a>
                    </li>
                  )
                }
              </ul>
            </div>
          </div>
        </div>
      )
    }]
  }
}

export default FooterStructure


// WEBPACK FOOTER //
// ./app/javascript/app/site/structures/footer/index.js